document.addEventListener('DOMContentLoaded', function() {
  var waveContainers = document.querySelectorAll('.wknd-wave-container.wknd-wave-bottom');
  waveContainers.forEach(function(wave, index) {
    // Use (index + 1) so that the first wave (index 0) isn't offset,
    // and the second (index 1), fourth (index 3), etc. get the offset.
    if ((index + 1) % 2 === 0) {
      wave.classList.add('wave-offset');
    }
  });
});
